import { ButtonPrimary } from '@/components/Form';
import Modal from '@/components/Modal';
import { Body } from '@/components/Typography';
import { Box, Spacer } from '@chakra-ui/react';
import { type FC } from 'react';
import type { SuccessStepProps } from './types';

const SuccessStep: FC<SuccessStepProps> = ({ onSuccess }) => {
  return (
    <Modal
      disabled
      data-testid="modal_setup2fa_success"
      onClose={() => {}}
      isOpen
      noMaxHeight={true}
      maxWidth={'327px'}
      noHeader
      hasCloseButton={false}
    >
      <Box textAlign="left">
        <Body variant="Bold16" color="darkWillow">
          Autentikasi 2 Lapis Telah Aktif
        </Body>
        <Spacer h="8px" />
        <Body variant="Default14" color="shade04">
          IDN Connect akan meminta kode autentikasi setiap kali kamu login pada perangkat baru atau perangkat yang tidak dikenali. Untuk merubah peraturan ini silakan buka di pengaturan Akun.
        </Body>
        <Spacer h="16px" />
        <ButtonPrimary width="100%" onClick={onSuccess}>
          Selesai
        </ButtonPrimary>
      </Box>
    </Modal>
  )
}

export default SuccessStep;
